import {Setting} from "./Setting";

export const technologySetting: Setting = {
    key: "Technology",
    title: "Технологии",
    description: "Технологии описывают уровень научного и технического прогресса мира, доступные инструменты, механизмы и изобретения, а также их влияние на повседневную жизнь, экономику и общество. Они играют важную роль в создании уникального мира и его атмосферы",
    components: [
        {
            title: "Уровень технологического развития",
            subComponents: [
                {
                    title: "Примитивный",
                    description: "Каменные и деревянные орудия, ручной труд, отсутствие сложных механизмов.",
                    examples: ["Пещерные люди, использующие каменные топоры."]
                },
                {
                    title: "Средневековый",
                    description: "Кузнечное дело, простая механика (водяные и ветряные мельницы), оружие вроде арбалетов и мечей.",
                    examples: ["Рыцари, сражающиеся на конях."]
                },
                {
                    title: "Индустриальный",
                    description: "Паровые машины, железные дороги, массовое производство, первые электрические устройства.",
                    examples: ["Фабрики, работающие на паровых машинах."]
                },
                {
                    title: "Современный",
                    description: "Компьютеры, автомобили, авиация, бытовая электроника, медицина.",
                    examples: ["Смартфоны, используемые в повседневной жизни."]
                },
                {
                    title: "Футуристический",
                    description: "Искусственный интеллект, нанотехнологии, космические корабли, виртуальная реальность.",
                    examples: ["Космические станции, обитаемые людьми."]
                },
                {
                    title: "Фантастический",
                    description: "Магические артефакты, биоорганические машины, технологии древних цивилизаций, синтез магии и науки.",
                    examples: ["Мечи, обладающие магической силой."]
                }]
        },
        {
            title: "Источник энергии",
            subComponents: [
                {
                    title: "Природные ресурсы",
                    description: "Древесина, уголь, нефть, вода, ветер, солнечный свет.",
                    examples: ["Ветряные мельницы, использующие энергию ветра."]
                },
                {
                    title: "Футуристические ресурсы",
                    description: "Ядерная энергия, антиматерия, термоядерный синтез.",
                    examples: ["Ядерные реакторы, обеспечивающие энергией города."]
                },
                {
                    title: "Фантастические источники",
                    description: "Магическая энергия, эфир, души, кристаллы или артефакты.",
                    examples: ["Кристаллы, используемые для создания магических устройств."]
                },
                {
                    title: "Ручной труд",
                    description: "Для примитивных или низкотехнологичных миров.",
                    examples: ["Люди, работающие в поле или на рынке."]
                }]
        },
        {
            title: "Транспорт",
            subComponents: [
                {
                    title: "Наземный",
                    description: "Лошади, телеги, паровозы, автомобили, мотоциклы, шагающие мехи.",
                    examples: ["Поезд, перевозящий пассажиров и грузы."]
                },
                {
                    title: "Воздушный",
                    description: "Дирижабли, самолеты, дроны, реактивные ранцы, летающие корабли.",
                    examples: ["Дирижабль, используемый для пассажирских перевозок."]
                },
                {
                    title: "Морской",
                    description: "Лодки, парусники, подводные лодки, высокотехнологичные корабли.",
                    examples: ["Подводная лодка, используемая для исследований."]
                },
                {
                    title: "Космический",
                    description: "Межзвездные корабли, станции, варп-двигатели.",
                    examples: ["Космический корабль, отправляющийся на другую планету."]
                },
                {
                    title: "Фантастический",
                    description: "Телепорты, порталы, летающие существа или магический транспорт.",
                    examples: ["Дракон, используемый для перелётов."]
                }]
        },
        {
            title: "Связь и информация",
            subComponents: [
                {
                    title: "Примитивная",
                    description: "Вестники, сигнальные костры, письма.",
                    examples: ["Почтовые голуби, переносящие сообщения."]
                },
                {
                    title: "Индустриальная",
                    description: "Телеграфы, газеты, радиосвязь.",
                    examples: ["Радиостанция, транслирующая новости."]
                },
                {
                    title: "Современная",
                    description: "Телефоны, интернет, спутники.",
                    examples: ["Смартфон, позволяющий общаться с другими людьми."]
                },
                {
                    title: "Футуристическая",
                    description: "Голографическая связь, телепатия через устройства, передача мыслей.",
                    examples: ["Устройство, позволяющее читать мысли."]
                },
                {
                    title: "Фантастическая",
                    description: "Магические книги, говорящие артефакты, связь через кристаллы.",
                    examples: ["Кристалл, используемый для передачи сообщений."]
                }]
        },
        {
            title: "Оружие и военные технологии",
            subComponents: [
                {
                    title: "Примитивное",
                    description: "Луки, копья, катапульты.",
                    examples: ["Лук, используемый для охоты."]
                },
                {
                    title: "Индустриальное",
                    description: "Пушки, огнестрельное оружие, танки.",
                    examples: ["Пулемёт, используемый на поле боя."]
                },
                {
                    title: "Современное",
                    description: "Автоматическое оружие, ракеты, дроны, кибероружие.",
                    examples: ["Беспилотник, используемый для разведки."]
                },
                {
                    title: "Футуристическое",
                    description: "Лазеры, плазменное оружие, экзоскелеты, мехи.",
                    examples: ["Энергетический меч, разрезающий сталь."]
                },
                {
                    title: "Фантастическое",
                    description: "Магические жезлы, клинки из света, энергетические щиты, биооружие.",
                    examples: ["Жезл, испускающий магические снаряды."]
                }]
        },
        {
            title: "Производство и промышленность",
            subComponents: [
                {
                    title: "Ручное производство",
                    description: "Ремесленные мастерские.",
                    examples: ["Кузница, где создаются мечи и доспехи."]
                },
                {
                    title: "Механизация",
                    description: "Паровые машины, заводы.",
                    examples: ["Фабрика, производящая паровые двигатели."]
                },
                {
                    title: "Автоматизация",
                    description: "Сборочные линии, роботы.",
                    examples: ["Робот, выполняющий монотонную работу."]
                },
                {
                    title: "Футуризация",
                    description: "3D-печать, нанозаводы, молекулярные синтезаторы.",
                    examples: ["3D-принтер, создающий предметы из пластика."]
                },
                {
                    title: "Фантастика",
                    description: "Алхимические лаборатории, создание вещей из магической энергии.",
                    examples: ["Лаборатория, где создаются магические зелья."]
                }]
        },
        {
            title: "Медицина",
            subComponents: [
                {
                    title: "Примитивная",
                    description: "Травничество, шаманизм.",
                    examples: ["Трава, используемая для лечения болезней."]
                },
                {
                    title: "Индустриальная",
                    description: "Аптеки, хирургия, первые антибиотики.",
                    examples: ["Аптека, предлагающая лекарства."]
                },
                {
                    title: "Современная",
                    description: "Вакцины, трансплантация органов, современные лекарства.",
                    examples: ["Вакцина, предотвращающая распространение болезни."]
                },
                {
                    title: "Футуристическая",
                    description: "Генетическая модификация, кибернетика, искусственные органы.",
                    examples: ["Протез, заменяющий утраченный орган."]
                },
                {
                    title: "Фантастическая",
                    description: "Лечение заклинаниями, магические исцеляющие предметы, эликсиры.",
                    examples: ["Зелье, восстанавливающее здоровье."]
                }]
        },
        {
            title: "Бытовые технологии",
            subComponents: [
                {
                    title: "Простые",
                    description: "Кухонная утварь, очаг, лампы.",
                    examples: ["Лампа, освещающая дом."]
                },
                {
                    title: "Механические",
                    description: "Часы, стиральные машины, газовые лампы.",
                    examples: ["Часы, показывающие время."]
                },
                {
                    title: "Электрические",
                    description: "Холодильники, телевизоры, компьютеры.",
                    examples: ["Холодильник, хранящий продукты."]
                },
                {
                    title: "Футуристические",
                    description: "Умные дома, роботы-домашние помощники, устройства дополненной реальности.",
                    examples: ["Робот-пылесос, убирающий дом."]
                },
                {
                    title: "Фантастические",
                    description: "Автономные магические артефакты, самоочищающаяся посуда.",
                    examples: ["Посуда, моющаяся сама."]
                }]
        },
        {
            title: "Влияние на общество",
            subComponents: [
                {
                    title: "Социальные последствия",
                    description: "Расслоение общества, доступность технологий для разных классов.",
                    examples: ["Разделение на богатых и бедных."]
                },
                {
                    title: "Экологическое воздействие",
                    description: "Загрязнение, использование ресурсов, катастрофы.",
                    examples: ["Загрязнение реки из-за промышленных выбросов."]
                },
                {
                    title: "Эволюция профессий",
                    description: "Замена людей машинами, новые профессии, связанные с технологиями.",
                    examples: ["Программисты, создающие программное обеспечение."]
                }]
        }
    ],
    prompt: {
        component: {
            list: "Перечисли возможные компоненты технологий и опиши их если они применимы к истории. Не ограничивайся основными компонентами если необходимо",
            single: "Сгенерируй компонент технологий для мира. Опиши ключевые аспекты, структуры и последствия технологического развития.",
            extend: "Дополни описание компонента технологий и разбей на абзацы. Как компонент влияет на мир и персонажей."
        }, element: {
            list: "Перечисли возможные элементы технологий и опиши их если они применимы к истории",
            single: "Сгенерируй элемент технологий для мира. Опиши ключевые аспекты, структуры и последствия технологического развития.",
            extend: "Дополни описание элемента технологий и разбей на абзацы. Как элемент влияет на мир и персонажей."
        }, lore: {
            list: "Создай элементы лора на основе этого элемента технологии. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента технологии. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора технологии и разбей на абзацы."
        }
    }
}